import React from 'react';
import { Badge } from '@themesberg/react-bootstrap';
import {
  returnUserReadableDateTime,
  returnUserReadableLocalDate,
} from '../datetime';
import { getTripBadgeStatus } from '../trips';
import { SchemeBadge } from './schemeTableRedesign';

export const infoTable = () => {
  return [
    {
      dataField: 'time',
      text: 'Updated At',
      formatter: (cell, row) => {
        return returnUserReadableDateTime(cell?.iso || cell);
      },
    },
    {
      dataField: 'user',
      text: 'Updated By',
    },
    {
      dataField: 'action',
      text: 'Update Type',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <SchemeBadge text={cell || '-'} />
          </div>
        );
      },
    },
    {
      dataField: 'changes',
      text: 'Change Summary',
      formatter: (cell, row) => {
        return (
          <>
            {cell?.map((item, index) => (
              <div key={index} className="mb-2">
                <div>
                  <strong>{item.field || '-'}:</strong>
                </div>
                <div>
                  {item.oldValue} → {item.newValue}
                </div>
              </div>
            ))}
          </>
        );
      },
    },
    {
      dataField: '',
      text: 'Applied Dates',
      formatter: (cell, row) => {
        const fromDate = row.fromDate?.iso;
        const toDate = row.toDate?.iso;
        return (
          <div className="d-block">
            {fromDate ? returnUserReadableLocalDate(fromDate) : '-'} to{' '}
            {toDate ? returnUserReadableLocalDate(toDate) : 'Indefinite'}
          </div>
        );
      },
    },
  ];
};
